// What the advisory gate raised, and the two ways past it: pick the record it found, or say this
// is a different entity. Shared by the register's form and the deal form's dialog. The BD must be
// able to disagree, and be told plainly that they may - given a warning and no way past it, they
// will type a deliberately different name to get through, and the register ends up worse than
// with no check at all.

import { pickerMark } from './labels.js';

export default function DuplicateReview({ flagged, onPick }) {
  return (
    <div className="duplicate-review">
      <h4>This may already be on the register</h4>
      {flagged.message && <p className="hint">{flagged.message}</p>}

      <ul className="counterparty-suggestions">
        {flagged.candidates.map((candidate) => (
          <li key={candidate.counterparty_id}>
            <button type="button" onClick={() => onPick(candidate)}>
              <span className="suggestion-name">{candidate.name}</span>
              {pickerMark(candidate.status) && (
                <span className="suggestion-status">{pickerMark(candidate.status).word}</span>
              )}
            </button>
          </li>
        ))}
      </ul>

      <p className="hint">
        Subsidiaries and different legal forms are separate counterparties. If this is one of
        those, save it.
      </p>
    </div>
  );
}
